import { z } from "zod";
import {
    Control,
    DefaultValues,
    FieldPathByValue,
    Mode,
    useForm,
    UseFormReturn,
} from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

export const useKForm = <TSchema extends z.Schema>({
    schema,
    defaultValues,
    mode,
    disabled,
}: {
    schema: TSchema;
    defaultValues?: DefaultValues<z.input<TSchema>>;
    mode?: Mode;
    disabled?: boolean;
}): UseFormReturn<z.input<TSchema>, any, z.output<TSchema>> => {
    return useForm({
        defaultValues,
        resolver: zodResolver(schema),
        mode,
        disabled,
    });
};

export type TZodPath<
    TFieldValues extends z.Schema,
    TValue = any,
> = FieldPathByValue<z.input<TFieldValues>, TValue>;

export type ZodControlledField<TFieldValues extends z.Schema, TValue = any> = {
    control: Control<z.input<TFieldValues>, any, z.output<TFieldValues>>;
    name: TZodPath<TFieldValues, TValue>;
};
